import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import './NotifyStaff.scss';
import { AlertNotice, ModalInfo, Input, Textarea, TooltipItem } from 'shared/components';
import { getPersonnelRolesName } from 'shared/helpers';
import PropTypes from 'prop-types';
import StaffService from '../StaffService';

const getInitialStaff = (staffGroups) =>
  staffGroups.assignedStaff.map((item, index) => ({
    ...item,
    checked: false,
    id: index + 1,
  }));

class NotifyStaff extends Component {
  constructor(props) {
    super(props);
    const { staffGroups } = this.props;
    const staff = getInitialStaff(staffGroups);

    this.state = {
      staff,
      checkedAll: false,
      note: '',
    };
  }

  componentDidUpdate(prevProps) {
    const { staffGroups } = this.props;
    const staff = getInitialStaff(staffGroups);
    if (this.props.modalIsOpen !== prevProps.modalIsOpen && this.props.modalIsOpen) {
      this.setState({
        staff,
        checkedAll: false,
        note: '',
      });
    }
  }

  handleAllChecked = (event) => {
    const { staff } = this.state;
    staff.forEach((item) => (item.checked = event.target.checked));
    this.setState({
      staff,
      checkedAll: !this.state.checkedAll,
    });
  };

  handleItemCheck = (event) => {
    const { staff } = this.state;
    staff.forEach((item) => {
      if (item.id === Number(event.target.id)) {
        item.checked = event.target.checked;
      }
    });
    const notAllSelected = staff.find((item) => !item.checked);
    this.setState({ staff, checkedAll: !notAllSelected && !this.state.checkedAll });
  };

  handleChangeTextArea = (event) => {
    this.setState({
      ...this.state,
      note: event.target.value,
    });
  };

  onSubmitNotifyStaff = () => {
    const {
      testCenterCycle,
      tcEvent,
      handleSubmitNotifyModal,
      closeModal,
      staffGroups,
      currentUser,
    } = this.props;

    const { staff, note } = this.state;

    const filteredStaff = staff
      .filter((item) => item.checked)
      .map((pers) => ({
        coordinatorEmail: staffGroups.tdCoordinator.emailAddress ?? currentUser.emailAddress,
        firstName: pers.firstName,
        host: window.location.origin,
        note,
        role: getPersonnelRolesName()[pers.roleName],
        staffEmail: pers.emailAddress,
        testCenterName: testCenterCycle.testCenterProgram.testCenter.name,
        testingEventName: tcEvent.testingEvent.name,
      }));
    if (filteredStaff.length) {
      StaffService.notifyStaff(filteredStaff)
        .then(() => {
          handleSubmitNotifyModal(false);
        })
        .catch(() => {
          handleSubmitNotifyModal(true);
        });
    } else {
      closeModal();
    }
  };

  render() {
    const { modalIsOpen, closeModal } = this.props;
    const { staff } = this.state;
    return (
      <ModalInfo
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        headerTitle={this.props.t('staffAndRoomsManagement.notifyStaff.title')}
        onSubmit={this.onSubmitNotifyStaff}
        saveLabel={this.props.t('staffAndRoomsManagement.notifyStaff.sendNotification')}
        className="notify-staff-info">
        <section className="notify-assigned-staff-modal">
          <p className="subtitle">{this.props.t('staffAndRoomsManagement.notifyStaff.subTitle')}</p>
          <div className="notify-staff-header">
            <div>
              <Input
                type="checkbox"
                name="selectAll"
                id="selectAll"
                onChange={this.handleAllChecked}
                checked={this.state.checkedAll}>
                <label className="notify-staff-label" htmlFor="selectAll">
                  {this.props.t('staffAndRoomsManagement.notifyStaff.selectAll')}
                </label>
              </Input>
            </div>
            <div>{this.props.t('staffAndRoomsManagement.notifyStaff.role')}</div>
            <div className="hide-mobile">
              {this.props.t('staffAndRoomsManagement.notifyStaff.email')}
            </div>
          </div>
          <ul className="notify-staff-items">
            {staff.length ? (
              staff.map((item) => (
                <li key={item.id}>
                  <div className="text-ellipsis">
                    <Input
                      type="checkbox"
                      name="staffItem"
                      id={`${item.id}`}
                      onChange={this.handleItemCheck}
                      checked={item.checked}>
                      <label htmlFor={item.id}></label>
                      <TooltipItem
                        item={`${item.lastName}, ${item.firstName} `}
                        customClass="notify-staff-label"
                      />
                    </Input>
                  </div>
                  <div>
                    <div
                      className="staff-role"
                      data-bs-toggle="popover"
                      data-bs-placement="top"
                      data-bs-trigger="hover"
                      data-bs-content={getPersonnelRolesName()[item.roleName]}>
                      {item.roleShortName}
                    </div>
                  </div>
                  <TooltipItem item={item.emailAddress} customClass="staff-email" />
                </li>
              ))
            ) : (
              <AlertNotice message={this.props.t('staffManagement.notifyStaff.noStaff')} />
            )}
          </ul>
          <div className="gray-separator" />
          <div className="add-text-area">
            <div className="add-text-description">
              {this.props.t('staffAndRoomsManagement.notifyStaff.textDescription')}
            </div>
            <Textarea
              name="staff-notes"
              label={this.props.t('staffAndRoomsManagement.notifyStaff.extraText')}
              maxLength={360}
              onChange={this.handleChangeTextArea}
              value={this.state.note}
              optionalText="Optional"
            />
          </div>
          <div className="gray-separator" />
        </section>
      </ModalInfo>
    );
  }
}

export default withTranslation()(NotifyStaff);
NotifyStaff.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleSubmitNotifyModal: PropTypes.func.isRequired,
  staffGroups: PropTypes.shape({
    assignedStaff: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tdCoordinator: PropTypes.shape({}),
  }).isRequired,
  testCenterCycle: PropTypes.shape({}).isRequired,
  tcEvent: PropTypes.shape({}).isRequired,
  currentUser: PropTypes.shape({ emailAddress: PropTypes.string }).isRequired,
  t: PropTypes.func.isRequired,
};
